import styled from 'styled-components';
import useUIContext from '~/ui/use-ui-context';

const HeroWrapperStyled = styled.div`
	grid-area: hero;
	overflow: hidden;
	background-color: var(--hero-bg);
	background-image: var(--hero-img);
	background-position: var(--hero-bg-position);
	background-repeat: var(--hero-bg-repeat);
	background-size: var(--hero-pattern-size);
	filter: ${({ uiContext }) => (uiContext.hasHeroBlurred ? 'blur(7px)' : '')};
`;

const HeroWrapper = props => {
	const uiContext = useUIContext();
	return <HeroWrapperStyled {...props} uiContext={uiContext} />;
};

export default HeroWrapper;
